
import { Vue, Component, Prop } from "vue-property-decorator";
import S3Image from "@/components/common/s3-image.vue";

@Component({
    components: {
        S3Image,
    }
})
export default class Chip extends Vue {
    @Prop({ type: String, default: "default" }) readonly variant!: string;
    @Prop({ type: Object, default: () => { return { id: "", name: "" } } }) readonly chipData!: { id: string, name: string };
    @Prop({ type: String, default: "" }) readonly avatar!: string;
    @Prop({ type: String, default: "" }) readonly chipText!: string;
    @Prop({ type: Boolean, default: false }) readonly wrapChip!: boolean;
     @Prop({ type: Boolean, default: "" }) readonly chipClass!: string;
}
